import { CertificadoEntry } from './../../../../../../shared/entrys/certificado.entry';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CertificadosService } from './certificados.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';


@Component({
  selector: 'app-certificado',
	templateUrl: './certificados.component.html',
	styleUrls: ['./certificados.component.scss']
})
export class CertificadosComponent implements OnInit {

	headers: string[] = [];
	certificados: Array<CertificadoEntry>;
  formFiltroCertificado: FormGroup;
  dataTabla: DatoPaginadoModel;
  FechaIni;
  FechaFin;


	constructor(private formBuilder: FormBuilder, private certificadosService: CertificadosService, private authService: AuthService) { }

	ngOnInit() {
		this.headers = ['Prestador', 'Fecha Expedición', 'Nombre del Establecimiento', 'Numero Expedición'];
		this.formFiltroCertificado = this.formBuilder.group({
			certificado_generado_id: [null, Validators.required],
			fechaInicio: ['', Validators.required],
			fechaFin: ['', Validators.required]
    });


		this.certificadosService.get(this.formFiltroCertificado.value).subscribe(resultado => {
			if (resultado.result) {
        this.dataTabla = resultado.data as DatoPaginadoModel;
				this.certificados = this.dataTabla.items as Array<CertificadoEntry>;
			}
		});
	}

	onFiltrar() {

    this.certificadosService.getFilter(this.formFiltroCertificado.value).subscribe(resultado => {
        if (resultado.result) {
          this.certificados = resultado.data.items as Array<CertificadoEntry>;
        }
      });
    }
    onPaginado(value : number){
      this.certificadosService.getPaginator(this.formFiltroCertificado.value,value).subscribe(resultado => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
          this.certificados = this.dataTabla.items as Array<CertificadoEntry>;
        }
      });

    }

}
